import { render, staticRenderFns } from "./Restablecer.vue?vue&type=template&id=1d90824d"
import script from "./Restablecer.vue?vue&type=script&lang=js"
export * from "./Restablecer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports